module.exports = __webpack_public_path__ + "images/emoji/girl.e112e12c318805708157.png";